// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

//  Component Imports
import { above } from '../../style/design-system'
import NavMobile from '../navigation/NavMobile'
import AboveNav from './AboveNav'
import HeaderDesktop from './HeaderDesktop'

// Style Imports

const GlobalHeader = ({ className }) => (
  <header className={className}>
    <NavMobile className="py-4" />
    <div className="d-none d-lg-block desktop-header-wrapper">
      <AboveNav />
      <HeaderDesktop />
    </div>
  </header>
)

GlobalHeader.propTypes = {
  className: PropTypes.string,
}

GlobalHeader.defaultProps = {
  className: '',
}

export default styled(GlobalHeader)`
  padding-bottom: 63px;
  position: relative;
  z-index: 10;

  ${above.lg`
    padding-bottom: 7.68rem;
  `}

  .active-link {
    font-weight: 900;
  }

  .desktop-header-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }
`
